<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useProfileStore } from '@/stores/profile'
import { useCarinfoStore } from '@/stores/car-info'
import { usePageNavi } from '@/composables/usePageNavi.js'
import UTAOnline from '@/components/UTAOnline.vue'
import UTAConnectionType from '@/components/UTAConnectionType.vue'
import checkArrayIncludes from '@/helpers/checkArrayIncludes'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const { isOpenPageNavi, togglePageNavi } = usePageNavi()

const translaterStore   = useTranslaterStore()
const profileStore      = useProfileStore()
const carinfoStore      = useCarinfoStore()

const getTranslate  = computed(() => translaterStore.getTranslate)
const profile       = computed(() => profileStore.profile)
const carinfo       = computed(() => carinfoStore.carinfo)
</script>

<template>
    <div class="uta-aside-navi">
        <nav class="navbar navbar-expand-lg uta-aside-navi__navbar">
            <div class="navbar-brand uta-aside-navi__navbar-header">
                {{ carinfo.data?.vin || '-' }}
                <div class="uta-car-connection">
                    <div class="uta-car-connection__status">
                        <UTAOnline />
                    </div>
                    <div class="uta-car-connection__type">
                        <UTAConnectionType />
                    </div>
                </div>
            </div>
            <button 
                class="navbar-toggler uta-aside-navi__button"
                type="button"
                @click="togglePageNavi"
            >
                <div class="uta-aside-navi__icon" :class="{ 'uta-aside-navi__icon--close': isOpenPageNavi}">
                    <div class="uta-aside-navi__icon-item"></div>
                    <div class="uta-aside-navi__icon-item"></div>
                    <div class="uta-aside-navi__icon-item"></div>
                </div>

            </button>
            <div 
                class="uta-aside-navi__navbar-sidebar"
                :class="{ 'uta-aside-navi__navbar-sidebar--opened': isOpenPageNavi }"
            >
                <ul class="navbar-nav uta-aside-navi__navbar-nav">
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid" class="uta-aside-navi__link">{{ getTranslate.MENU_CAR_INFO }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/map'" class="uta-aside-navi__link" v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN', 'GEODATA'])">{{ getTranslate.MENU_CAR_MAP }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/trips'" class="uta-aside-navi__link" v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN', 'GEODATA'])">{{ getTranslate.MENU_CAR_TRIPS }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/areas'" class="uta-aside-navi__link" v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN', 'GEODATA'])">{{ getTranslate.MENU_CAR_AREAS }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/rights'" class="uta-aside-navi__link" v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN'])">{{ getTranslate.MENU_CAR_RIGHTS }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/ecus'" class="uta-aside-navi__link" v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN', 'DIAGNOSTIC'])">{{ getTranslate.MENU_CAR_DIAG }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/events'" class="uta-aside-navi__link">{{ getTranslate.MENU_CAR_EVENTS }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/history'" class="uta-aside-navi__link" v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN', 'LOGS_CAR'])">{{ getTranslate.MENU_CAR_HISTORY }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/cars/' + props.uuid + '/states'" class="uta-aside-navi__link">{{ getTranslate.MENU_CAR_STATES }}</router-link>
                    </li>
                </ul>
            </div>
            <transition name="fade">
                <div v-if="isOpenPageNavi" class="uta-aside-navi__navbar-backdrop" @click="togglePageNavi"></div>
            </transition>
        </nav>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/aside-navi.scss';
@import '@/assets/styles/scss/components/car/car-connection.scss';
</style>